// extracted by mini-css-extract-plugin
export var buttonarea = "ParagraphFileDownload-module--buttonarea--330cc";
export var downloadcard = "ParagraphFileDownload-module--downloadcard--f9487";
export var filemeta = "ParagraphFileDownload-module--filemeta--5bc3c";
export var filename = "ParagraphFileDownload-module--filename--9e062";
export var iconarea = "ParagraphFileDownload-module--iconarea--e2c3b";
export var inner = "ParagraphFileDownload-module--inner--bda63";
export var left = "ParagraphFileDownload-module--left--1cd8c";
export var outer = "ParagraphFileDownload-module--outer--b61b8";
export var textarea = "ParagraphFileDownload-module--textarea--7c8bd";